import { render, staticRenderFns } from "./after_sale_apply.vue?vue&type=template&id=1cc61daa&scoped=true"
import script from "./after_sale_apply.vue?vue&type=script&lang=js"
export * from "./after_sale_apply.vue?vue&type=script&lang=js"
import style0 from "./after_sale_apply.vue?vue&type=style&index=0&id=1cc61daa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc61daa",
  null
  
)

export default component.exports